import React from 'react'
import Grid from '@material-ui/core/Grid'

export default React.memo(props => <div style={Object.assign({ lineHeight: 1, width: '100%' }, props.style || {})}>
  {props.inline !== true &&
    <div className={'div-title'}
      style={props.children && props.children.props && (props.children.props.value === undefined || props.children.props.value === '') && {
        marginBottom: 0,
        //borderBottom: '0.5px dashed #D9D9D9'
      } || { marginBottom: 0 }}>
      {((props.title !== undefined && props.title !== '') || props.title === '.') &&
        (<Grid container spacing={0}
          style={Object.assign({ margin: 0, padding: 0, marginBottom: 0 }, props.style || {})}
          alignItems={'flex-start'} justify={'flex-start'}>
          <Grid item style={{ margin: 0, padding: 0 }} xs={12}>
            <fieldset className="fieldset-crit" style={props.style}>
              <legend style={{ marginBottom: 0, paddingBottom: 0, paddingTop: 0 }}
                className="legend-crit">{props.buttons}{props.title === '.' ?
                  <span style={{ margin: 0 }} /> : props.title}</legend>
              <Grid container spacing={props.spacing || 0} alignItems={props.alignItems || 'flex-start'} justify={props.justify || 'flex-start'} alignContent={props.alignContent || 'flex-start'}>
                {props.children}
              </Grid>
            </fieldset>
          </Grid>
        </Grid>) ||
        props.children
      }
    </div>
    ||
    <Grid container spacing={0}
      style={Object.assign({
        margin: 0,
        padding: 0,
        marginBottom: 0,
        position: 'relative',
      }, props.style || {})}
      alignItems={'center'} justify={'flex-start'}>
      <Grid item style={{
        margin: 0,
        padding: 0,
        //paddingRight: 10,
        minWidth: 70,
        position: 'relative',
        height: '100%'
      }} className="legend-crit">
        <Grid container spacing={0}
          style={{
            margin: 0,
            padding: 0,
            height: '100%'
          }}
          alignContent={'flex-start'}
          alignItems={'flex-start'}
          justify={props.children && props.children.props && props.children.props.multiline && 'flex-start' || 'center'}
          direction={'column'}>
          {props.title}
        </Grid>
      </Grid>

      <Grid className={'div-title'} item
        style={props.children && props.children.props && (props.children.props.value === undefined || props.children.props.value === '') && {
          marginBottom: 0,
          //borderBottom: '0.5px dashed #D9D9D9'
        } || { marginBottom: 0 }} xs>
        <Grid container spacing={0}
          style={{
            margin: 0,
            padding: 0,
            height: '100%'
          }}
          alignItems={props.alignItems || 'center'}
          alignContent={props.alignContent || 'center'}
          justify={props.justify || 'center'}
          direction={'column'}>
          {props.children}
        </Grid>
      </Grid>
    </Grid>
  }</div>)



// WEBPACK FOOTER //
// ./app/Components/Title.js